import { NotificationsEffects } from "./notifications.effects";

export const effects: any[] = [NotificationsEffects];

export * from "./notifications.effects";
